module.exports = __webpack_public_path__ + "97fe77c88eff61515766e7ff8afba87b.svg";